<template>
	<div class="Login">
		<div class="login-page">
			<div class="login-page__bg" aria-hidden="true">
				<div class="login-page__mesh"></div>
				<img class="login-page__photo" src="../assets/img/loginBg.jpg" alt="" />
			</div>

			<div class="login-page__shell">
				<div class="login-card">
					<header class="login-card__brand">
						<img class="login-card__logo" src="@/assets/maitu-logo.svg" alt="麦图光电" />
						<h1 class="login-card__title">定制家居产品供应链管理</h1>
						<p class="login-card__subtitle">经销商报价 · 客户管理 · 订单协同</p>
					</header>

					<el-form ref="loginForm" :model="loginForm" class="login-form" @submit.native.prevent="submitForm('loginForm')">
						<el-form-item prop="username" :rules="[{ required: true, message: '请输入账号' }]">
							<label class="login-field__label">账号</label>
							<el-input
								v-model="loginForm.username"
								class="login-field__input"
								:clearable="clearable"
								placeholder="手机号 / 用户名"
								prefix-icon="el-icon-user"
							/>
						</el-form-item>

						<el-form-item prop="password" :rules="[{ required: true, message: '请输入密码' }]">
							<label class="login-field__label">密码</label>
							<el-input
								v-model="loginForm.password"
								class="login-field__input"
								type="password"
								:show-password="passStatus"
								:clearable="clearable"
								placeholder="请输入登录密码"
								prefix-icon="el-icon-lock"
								@keyup.enter.native="submitForm('loginForm')"
							/>
						</el-form-item>

						<el-form-item class="login-form__submit">
							<el-button
								type="primary"
								class="login-submit"
								:loading="loginStatus"
								native-type="submit"
								@click="submitForm('loginForm')"
							>
								{{ loginStatus ? '登录中…' : '登 录' }}
							</el-button>
						</el-form-item>
					</el-form>

					<footer v-if="registerOpen" class="login-card__foot">
						<span class="login-card__hint">还没有账号？</span>
						<el-link type="primary" :underline="underline" @click="goRegister">立即注册</el-link>
					</footer>
					<p v-else-if="!statusLoading" class="login-card__closed">当前暂未开放注册，请联系管理员开通账号</p>
				</div>

				<aside class="login-visual" aria-hidden="true">
					<div class="login-visual__frame">
						<img src="../assets/img/banner.jpg" alt="" />
						<div class="login-visual__overlay">
							<p class="login-visual__tag">Supply Chain Platform</p>
							<h2>连接工厂与经销商的<br />数字化供应链</h2>
							<ul class="login-visual__features">
								<li>产品目录与报价</li>
								<li>客户与订单管理</li>
								<li>生产进度查询</li>
							</ul>
						</div>
					</div>
				</aside>
			</div>
		</div>
	</div>
</template>

<script>
	import { resolveDefaultFrontRoute } from '@/utils/front-rules'

	export default {
		name: 'Login',
		data() {
			return {
				clearable: !0,
				passStatus: !0,
				underline: !1,
				loginStatus: !1,
				registerOpen: !0,
				statusLoading: !0,
				loginForm: {
					username: '',
					password: ''
				}
			}
		},
		created() {
			this.reload();
			this.loadRegisterStatus();
		},
		methods: {
			reload() {},
			loadRegisterStatus() {
				const that = this
				that.statusLoading = !0
				that.$fetch('addons/hlm/api.User/registerStatus').then(function(res) {
					if (res.code == 1 && res.data) {
						that.registerOpen = Number(res.data.open) === 1
					}
				}).catch(function() {
					that.registerOpen = !0
				}).finally(function() {
					that.statusLoading = !1
				})
			},
			submitForm(loginForm) {
				let that = this
				if (that.loginStatus) return
				that.$refs[loginForm].validate((valid) => {
					if (valid) {
						that.loginStatus = !0
						that.$fetch('addons/hlm/api.User/login', that.loginForm).then(function(res) {
							if (res.code == 1) {
								let userInfo = JSON.stringify(res.data.userinfo), ruleList = JSON.stringify(res.data.rulelist)
								localStorage.setItem('userInfo', userInfo), localStorage.setItem('ruleList', ruleList)
								const categoryId = Number((res.data.userinfo && res.data.userinfo.quotation_category_id) || 0)
								if (categoryId > 0) {
									sessionStorage.setItem('quotation_category', String(categoryId))
								} else {
									sessionStorage.removeItem('quotation_category')
								}
								that.$message({
									message: '登录成功',
									type: 'success',
									duration: 1500,
									center: !0,
									onClose() {
										that.loginStatus = !1
										const ruleList = res.data.rulelist || {}
										const target = resolveDefaultFrontRoute(ruleList)
										if (target) {
											that.$router.replace(target)
										} else {
											that.$message.warning('当前账号暂无可访问的功能，请联系管理员')
											localStorage.clear()
											sessionStorage.removeItem('quotation_category')
										}
									}
								});
							} else {
								that.loginStatus = !1
							}
						}).catch(function(error) {
							console.log(error)
							that.loginStatus = !1
						})
					} else {
						return false;
					}
				});
			},
			goRegister() {
				this.$router.replace('/register')
			}
		}
	};
</script>

<style src="../assets/css/login.css"></style>
